import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
import { RedtailCredentialsModalModule } from 'IntegrationsApp/ts/features/redtail-credentials-modal/redtail-credentials-modal.module';
import { ConfigModule } from 'NewAngular/config/config.module';
import { SimpleDropdownModule } from 'NewAngular/features/components/dropdowns/simple-dropdown/simple-dropdown.module';
import { SingleSelectDropdownModule } from 'NewAngular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { MultilineFileUploadModule } from 'NewAngular/features/components/file-upload/multiline-file-upload/multiline-file-upload.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ConfirmModalModule } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { NavigationModule } from 'NewAngular/features/components/navigation/navigation.module';
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { ImageModule } from 'NewAngular/features/directives/image/image.module';
import { AccountIntegrationsPageComponent } from './components/account-integrations-page/account-integrations-page.component';
import { AccountSettingsNavigationComponent } from 'AccountsApp/ts/features/navigation/account-settings-navigation.component';
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'NewAngular/features/components/side-menu/side-menu.component';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class AccountIntegrationsModule {
}
AccountIntegrationsModule.ɵfac = function AccountIntegrationsModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AccountIntegrationsModule)(); };
AccountIntegrationsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AccountIntegrationsModule, bootstrap: [AccountIntegrationsPageComponent,
        AccountSettingsNavigationComponent,
        TopBarNavComponent,
        SideMenuComponent] });
AccountIntegrationsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        ConfigModule,
        ConfirmModalModule,
        IconModule,
        FormsModule,
        ImageModule,
        LoadingSymbolModule,
        ModalBaseModule,
        NavigationModule,
        SimpleDropdownModule,
        StoreModule.forRoot({}),
        DisabledModule,
        SingleSelectDropdownModule,
        MultilineFileUploadModule,
        RedtailCredentialsModalModule] });
